import { Button, Checkbox, Drawer, Form, Input, Space } from "antd";
import { userInfo } from "os";
import { useEffect, useRef, useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { BsCheck2, BsPrinter } from "react-icons/bs";
import { FiEdit } from "react-icons/fi";
import { IoAdd } from "react-icons/io5";
import { VscDiffAdded } from "react-icons/vsc";
// import { QRCode } from "react-qrcode-logo";
import ReactToPrint from "react-to-print";
import QRToyota from "../../../../components/shared/QRToyota";
import fetchSiteStations from "../../../../services/fetchSiteStations";
import { useFetchOneSiteQuery } from "../../../../store/endpoints/trace/site";
import {
  useCreateStationMutation,
  useUpdateStationMutation,
} from "../../../../store/endpoints/trace/stations";

export default function StationsPannel({
  isVisible,
  setShowStations,
  selected,
}: any) {
  const [active, setActive] = useState({ _id: null, name: "" });
  const { data: oneStation, isLoading } = useFetchOneSiteQuery(
    `${selected._id}`
  );
  const [createStation, createResult] = useCreateStationMutation();
  const [updateStation, updateResult] = useUpdateStationMutation();
  const [stations, setStations] = useState(selected.stations);
  const [showCreate, setShowCreate] = useState(false);
  const [form] = Form.useForm();
  const [updateForm] = Form.useForm();

  const qrpages = useRef(null);

  // const stations = !isLoading
  //   ? oneStation && oneStation.payload.stations
  //   : selected.stations;

  const handleCreateStation = async () => {
    const { isMain, name } = await form.validateFields();
    const data = {
      isMain,
      site: selected._id,
      name: name,
      description: name,
    };
    await createStation(data);
    await handleFetchStations();
  };

  const handleUpdateStation = async (station_id: any) => {
    const { isMain, name } = await updateForm.validateFields();
    const data = { isMain, name };
    await updateStation(station_id, data);
    await handleFetchStations();
  };

  const handleFetchStations = async () => {
    const data = await fetchSiteStations(selected._id);
    setStations(data.payload.stations);
  };

  useEffect(() => {
    handleFetchStations();
  }, [selected]);

  return (
    <Drawer
      title={
        <div className="flex items-center">
          <span className="mr-2 text-lg">{selected.name}'s Stations</span>
        </div>
      }
      placement={"right"}
      width={800}
      onClose={() => setShowStations(!isVisible)}
      visible={isVisible}
      closable={false}
      extra={
        <Space>
          <Button
            type="default"
            color="#E50000"
            onClick={() => setShowStations(!isVisible)}
            danger
          >
            <AiOutlineClose />
          </Button>
        </Space>
      }
    >
      <div className="font-toyota">
        <div className="flex py-1 border-b border-gray-300">
          <div className="flex justify-between items-center flex-1">
            <div className="flex items-center">
              <div className="w-36 font-bold">Stations</div>
            </div>
            <div className="font-bold">
              <ReactToPrint
                trigger={() => {
                  return (
                    <button className="border rounded-md px-2 py-1 flex items-center hover:bg-red-100">
                      <BsPrinter />
                      <span className="ml-2">Print</span>
                    </button>
                  );
                }}
                content={() => qrpages.current}
              />
            </div>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-2 m-4" ref={qrpages}>
          {stations?.map((station: any, index: number) => (
            <div
              className="col-span-4 sm:col-span-3 md:col-span-3 p-2"
              key={index}
            >
              {active._id === station._id ? (
                <div className="flex justify-between items-center">
                  <Form
                    name="normal_login"
                    className="login-form"
                    onFinish={() => handleUpdateStation(station.id)}
                    form={updateForm}
                  >
                    <Form.Item
                      name="name"
                      rules={[
                        {
                          required: false,
                          message: "Please add station name.",
                        },
                      ]}
                    >
                      <Input
                        defaultValue={station.name}
                        placeholder="Station name"
                      />
                    </Form.Item>

                    <Form.Item>
                      <Form.Item name="isMain" valuePropName="checked" noStyle>
                        <Checkbox defaultChecked={station.isMain}>
                          Main gate
                        </Checkbox>
                      </Form.Item>
                    </Form.Item>

                    <Form.Item>
                      <Button
                        danger
                        type="primary"
                        htmlType="submit"
                        className="login-form-button"
                      >
                        Update
                      </Button>
                      <Button
                        danger
                        type="default"
                        htmlType="submit"
                        className="login-form-button"
                        onClick={() => {
                          setActive({ _id: null, name: "" });
                        }}
                      >
                        Cancel
                      </Button>
                    </Form.Item>
                  </Form>
                </div>
              ) : (
                <div className="flex justify-between items-center">
                  <div className="flex flex-col">
                    <div className="flex justify-between items-center">
                      <div className="flex items-center">
                        <div className="mr-2">{index + 1}.</div>
                        <div
                          className={`truncate w-28 text-lg ${
                            station.isMain ? "text-green-600" : "text-gray-600"
                          } `}
                        >
                          {station.name}
                        </div>
                      </div>
                      {/* <button
                        onClick={() => {
                          setActive(station);
                        }}
                        className="flex justify-center items-center text-gray-700 border rounded-md p-2 bg-gray-100 hover:bg-gray-200 cursor-pointer"
                      >
                        <FiEdit />
                      </button> */}
                    </div>
                    <div className="w-auto">
                      <QRToyota value={`${station._id}`} title={"Toyota"} />
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))}
          <div className="flex justify-center items-center w-44">
            {showCreate ? (
              <Form
                name="normal_login"
                className="login-form"
                initialValues={{ isMain: false }}
                onFinish={handleCreateStation}
                form={form}
              >
                <Form.Item
                  name="name"
                  rules={[
                    { required: true, message: "Please add station name." },
                  ]}
                >
                  <Input placeholder="Station name" />
                </Form.Item>

                <Form.Item>
                  <Form.Item name="isMain" valuePropName="checked" noStyle>
                    <Checkbox>Main gate</Checkbox>
                  </Form.Item>
                </Form.Item>

                <Form.Item>
                  <Button
                    danger
                    type="primary"
                    htmlType="submit"
                    className="login-form-button"
                  >
                    Create
                  </Button>
                  <Button
                    danger
                    type="default"
                    htmlType="submit"
                    className="login-form-button"
                    onClick={() => setShowCreate(false)}
                  >
                    Cancel
                  </Button>
                </Form.Item>
              </Form>
            ) : (
              <button
                onClick={() => setShowCreate(true)}
                className="border p-4"
              >
                <VscDiffAdded />
              </button>
            )}
          </div>
        </div>
      </div>
    </Drawer>
  );
}
